import { useTheme } from "@mui/material/styles";
import { useMatchQuery } from "./useMatchQuery.js";
const useIsMobile = ()=>{
    const theme = useTheme();
    return useMatchQuery(theme.breakpoints.down('sm'));
};
export { useIsMobile };
